module.exports = __webpack_public_path__ + "static/img/u33.bd612ea3.png";